import { FeatureFlagEnabled } from "elements";
import { Redirect, Route, Switch } from "polyrouter";
import React from "react";
import { ProtectedRoute } from "TsRoleGuards";
import { DeviceInformation } from "./DeviceInformation";
import { Diagnostics } from "./Diagnostics";
import { PCAPLoader } from "./PCAP/PCAP";
import { ScreenCapture } from "./ScreenCapture/ScreenCapture";

export const DiagnosticsRouter: React.FC<{
  deviceId: string;
  tenantId: string;
  deviceModel: string;
  siteId: string;
  connected: boolean;
  isPolyOs: boolean;
  isLogDownloadSupported: boolean;
  isPcapDownloadSupported: boolean;
  isLogToFlashSupported: boolean;
  hasRelays: boolean;
}> = ({
  deviceId,
  tenantId,
  deviceModel,
  siteId,
  connected,
  isPolyOs,
  isLogDownloadSupported,
  isPcapDownloadSupported,
  isLogToFlashSupported,
  hasRelays
}) => {
  return (
    <Switch>
      <ProtectedRoute nest path="/diagnostics" requirement="set:device:config">
        {isLogDownloadSupported && (
          <FeatureFlagEnabled feature="DOWNLOAD_LOGS">
            <Diagnostics
              deviceId={deviceId}
              connected={connected}
              isLogToFlashSupported={isLogToFlashSupported}
            />
          </FeatureFlagEnabled>
        )}
      </ProtectedRoute>
      <Route nest path="/device-information">
        <DeviceInformation deviceId={deviceId} isPolyOs={isPolyOs} />
      </Route>
      <ProtectedRoute nest path="/pcap" requirement="access:device:logs">
        {isPcapDownloadSupported && (
          <FeatureFlagEnabled feature="DOWNLOADING_PCAP">
            <PCAPLoader
              deviceId={deviceId}
              tenantId={tenantId}
              deviceModel={deviceModel}
              siteId={siteId}
              connected={connected}
              isPolyOs={isPolyOs}
            />
          </FeatureFlagEnabled>
        )}
      </ProtectedRoute>
      <ProtectedRoute
        nest
        path="/screen-capture"
        requirement="access:device:logs"
      >
        {isPcapDownloadSupported && hasRelays && (
          <FeatureFlagEnabled feature="EDGE_RELAY">
            <ScreenCapture
              deviceId={deviceId}
              tenantId={tenantId}
              connected={connected}
            />
          </FeatureFlagEnabled>
        )}
      </ProtectedRoute>
      <Route nest path="/">
        <Redirect nest to="device-information" />
      </Route>
    </Switch>
  );
};
